export const ROUNDUP_TYPES = {
  NEAREST_9: 'nearest_9',
  TIER_49_99: 'tier_49_99',
  ALWAYS_99: 'always_99',
};

export const ROUNDUP_THRESHOLD = 4;
